import * as React from 'react';

function Promo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 10.999h-8v-3h8v3zm-8 10h6v-9h-6v9zM12.5 6.18c-.055-.335 1.739-1.37 4.338-1.903 1.079-.222 1.726-.286 2.113-.286.379 0 .508.06.548.099.043.226-.563 1.07-1.487 1.773-.549.417-1.467 1.115-2.859 1.135-1.359.04-2.606-.538-2.653-.818zm-1 0c-.047.28-1.335.86-2.653.818-1.392-.02-2.31-.718-2.859-1.135-.924-.702-1.53-1.547-1.499-1.753.047-.048.184-.117.581-.117.392 0 1.034.067 2.092.284 2.599.534 4.393 1.568 4.338 1.903zm-.5 4.818H3v-3h8v3zm-6 10h6v-9H5v9zm13.15-14c.179-.123.338-.241.467-.34.18-.136 1.757-1.363 1.875-2.43a.985.985 0 00-.219-.764c-.607-.718-2.195-.463-3.636-.167-.174.036-3.387.715-4.637 1.918-1.25-1.203-4.463-1.882-4.637-1.918-1.439-.296-3.028-.552-3.636.168a.981.981 0 00-.219.764c.118 1.066 1.695 2.293 1.875 2.43.129.098.288.216.467.339H2.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5H4v9.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-9.5h1.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-3.35z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Promo;
